import { useCallback, useEffect, useState } from "react";

import Combobox from "../../../shared/ui/Field/Combobox";
import Field from "../../../shared/ui/Field/Field";
import { useGeoSettlementSearch } from "../hooks/useGeoSettlementSearch";

function GeoSettlementAutocomplete({
  id,
  regionCode,
  enabled,
  selectedSettlement,
  onSelect,
  error,
  disabled = false,
  disabledHelp,
}) {
  const [query, setQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const { options, loading, error: searchError } = useGeoSettlementSearch({
    regionCode,
    query,
    enabled: enabled && !disabled,
  });

  useEffect(() => {
    if (!selectedSettlement) {
      setQuery("");
      setIsSearching(false);
    }
  }, [selectedSettlement]);

  const displayValue =
    selectedSettlement && !isSearching ? selectedSettlement.name : query;

  const handleChange = useCallback((event) => {
    setIsSearching(true);
    setQuery(event.target.value);
  }, []);

  const handleSelect = useCallback(
    (option) => {
      if (!option?.raw) return;
      setQuery("");
      setIsSearching(false);
      onSelect(option.raw);
    },
    [onSelect],
  );

  const handleOpen = useCallback(() => {
    if (selectedSettlement && !isSearching) {
      setIsSearching(true);
      setQuery("");
    }
  }, [isSearching, selectedSettlement]);

  return (
    <div className="geo-settlement-autocomplete geo-canonical-field">
      <Field
        id={id}
        label="Населений пункт"
        help={
          disabledHelp
            ?? (disabled
              ? "Для міста зі спеціальним статусом населений пункт визначається автоматично."
              : "Введіть щонайменше 2 символи для пошуку.")
        }
        error={error}
        required={enabled && !disabled}
        className="geo-canonical-field__field"
      >
        <Combobox
          name={id}
          value={displayValue}
          onChange={handleChange}
          options={options}
          loading={loading}
          error={searchError}
          disabled={disabled || !enabled}
          emptyHint={
            enabled && !disabled
              ? "Введіть назву населеного пункту (мінімум 2 символи)."
              : undefined
          }
          emptyResultsLabel={
            query.trim().length >= 2
              ? `За запитом «${query.trim()}» нічого не знайдено.`
              : undefined
          }
          onSelect={handleSelect}
          onOpen={handleOpen}
          placeholder={
            disabled ? "Визначається автоматично" : "Напр.: Бровари"
          }
          autoComplete="off"
        />
      </Field>
    </div>
  );
}

export default GeoSettlementAutocomplete;
